var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 3.5H10V3.25C10 2.56075 9.43925 2 8.75 2H7.25C6.56075 2 6 2.56075 6 3.25V3.5H3.75C3.474 3.5 3.25 3.724 3.25 4V4.75C3.25 5.026 3.474 5.25 3.75 5.25H12.25C12.526 5.25 12.75 5.026 12.75 4.75V4C12.75 3.724 12.526 3.5 12.25 3.5ZM7 3.25C7 3.11225 7.11225 3 7.25 3H8.75C8.88775 3 9 3.11225 9 3.25V3.5H7V3.25Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.07 5.91375C11.9753 5.8095 11.8408 5.75 11.7 5.75H4.30003C4.15928 5.75 4.02478 5.8095 3.93003 5.91375C3.83528 6.018 3.78903 6.1575 3.80228 6.29775L4.41678 12.7198C4.48653 13.4498 5.12878 14.0002 5.91078 14.0002H10.0893C10.871 14.0002 11.5135 13.4498 11.5833 12.7198L12.1978 6.29775C12.2113 6.1575 12.1648 6.018 12.07 5.91375ZM6.83153 12.749C6.82078 12.7495 6.81028 12.75 6.79953 12.75C6.53778 12.75 6.31778 12.5465 6.30103 12.2815L6.00103 7.5315C5.98378 7.256 6.19303 7.0185 6.46853 7.001C6.74478 6.986 6.98178 7.193 6.99903 7.4685L7.29903 12.2185C7.31628 12.494 7.10703 12.7315 6.83153 12.749ZM9.69903 12.2815C9.68228 12.5465 9.46228 12.75 9.20053 12.75C9.19003 12.75 9.17928 12.7497 9.16853 12.749C8.89278 12.7315 8.68378 12.494 8.70103 12.2185L9.00103 7.4685C9.01853 7.19275 9.25478 6.9855 9.53153 7.001C9.80728 7.0185 10.0163 7.256 9.99903 7.5315L9.69903 12.2815Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBin);
export default __webpack_public_path__ + "static/media/trashBin.3af93cf174f8b689686028c5005773b5.svg";
export { ForwardRef as ReactComponent };